import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCopy, FiCheck, FiCode, FiExternalLink } = FiIcons;

const EmbedModal = ({ isOpen, onClose, shareUrl }) => {
  const [copied, setCopied] = useState(false);
  
  const embedCode = `<iframe 
  src="${shareUrl}" 
  width="100%" 
  height="500px" 
  frameborder="0" 
  allow="autoplay"
></iframe>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(embedCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="bg-white rounded-[2rem] shadow-2xl w-full max-w-lg overflow-hidden"
          >
            <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-[#00AEEF] text-white flex items-center justify-center">
                  <SafeIcon icon={FiCode} className="text-xl" />
                </div>
                <div>
                  <h3 className="font-black text-gray-900 uppercase tracking-tight">Embed Player</h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase">Add this to your website</p>
                </div>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-gray-200 rounded-full transition-colors">
                <SafeIcon icon={FiX} className="text-gray-500" />
              </button>
            </div>

            <div className="p-8">
              <p className="text-sm text-gray-600 mb-4 font-medium">
                Copy the code below and paste it into your website's HTML editor to embed the radio player.
              </p>
              
              <div className="relative group">
                <pre className="bg-gray-900 text-cyan-400 p-6 rounded-2xl text-xs overflow-x-auto font-mono leading-relaxed border border-gray-800">
                  {embedCode}
                </pre>
                <button 
                  onClick={handleCopy}
                  className="absolute top-4 right-4 flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg text-[10px] font-bold uppercase tracking-widest backdrop-blur-md transition-all"
                >
                  <SafeIcon icon={copied ? FiCheck : FiCopy} />
                  {copied ? 'Copied!' : 'Copy Code'}
                </button>
              </div>

              <div className="mt-8 flex gap-4">
                <button 
                  onClick={() => window.open(shareUrl, '_blank')}
                  className="flex-1 flex items-center justify-center gap-2 py-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-2xl font-bold text-sm transition-colors"
                >
                  <SafeIcon icon={FiExternalLink} />
                  Preview Link
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default EmbedModal;